<template>
  <div>
    <div class="noti">
      <!-- <div class="history-register">
        Lịch sử đăng ký <span>{{ numberTuChoi }}</span>
      </div> -->
      <div class="trang-thai">
        <div class="text-cho-duyet" v-if="this.trangThaiDuyet == 'dang_cho'">
          Trạng thái: Chờ duyệt
        </div>
        <div class="text-huy" v-if="this.trangThaiDuyet == 'tu_choi'">
          Trạng thái: Từ chối
        </div>
        <div class="text-da-duyet" v-if="this.trangThaiDuyet == 'da_duyet'">
          Trạng thái: Đã duyệt
        </div>
        <div class="text-dang-xu-ly" v-if="this.trangThaiDuyet == 'dang_xu_ly'">
          Trạng thái: Đang xử lý
        </div>
      </div>
    </div>
    <div class="tu-choi-group" v-show="this.trangThaiDuyet == 'tu_choi'">
      <div class="tu-choi-btn">Lý do</div>
      <el-input type="textarea" :rows="5" v-model="this.liDo"></el-input>
    </div>
    <div>
      <el-collapse v-model="activeNames" class="mt-2">
        <el-collapse-item name="1">
          <template slot="title">
            <i class="header-icon el-icon-info"></i> LỊCH SỬ ĐĂNG KÝ
            <span class="value-list">{{ numberTuChoi }}</span>
          </template>

          <el-table
            :data="mData.tableRules.data"
            border
            class="mt-3"
            max-height="400"
          >
            <el-table-column prop="" label="STT" width="50">
              <template slot-scope="scope">
                <div class="text-center">
                  {{ mData.tableRules.offset + scope.$index + 1 }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Trạng thái" align="center" width="120">
              <div slot-scope="scope">
                <div v-if="scope.row.trang_thai == 'tu_choi'" class="text-box">
                  <p
                    class="text-huy"
                    style="padding: 0px 5px; border-radius: 5px"
                  >
                    Từ chối
                  </p>
                </div>
                <div v-if="scope.row.trang_thai == 'da_duyet'" class="text-box">
                  <p
                    class="text-da-duyet"
                    style="padding: 0px 5px; border-radius: 5px"
                  >
                    Đã duyệt
                  </p>
                </div>
                <div v-if="scope.row.trang_thai == 'dang_cho'" class="text-box">
                  <p
                    class="text-cho-duyet"
                    style="padding: 0px 5px; border-radius: 5px"
                  >
                    Chờ duyệt
                  </p>
                </div>
                <div
                  v-if="scope.row.trang_thai == 'dang_xu_ly'"
                  class="text-box"
                >
                  <p
                    class="text-dang-xu-ly"
                    style="padding: 0px 5px; border-radius: 5px"
                  >
                    Đang xử lý
                  </p>
                </div>
              </div>
            </el-table-column>
            <el-table-column
              prop="ten_dong_ho"
              label="Tên dòng họ"
              min-width="150"
              :sortable="mData.tableRules.allowSorting"
            >
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  :href="scope.row.url"
                  target="_blank"
                  >{{ scope.row.ten_dong_ho }}</el-link
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="dia_chi"
              label="Địa chỉ"
              min-width="250"
            ></el-table-column>
            <el-table-column
              prop="xung_ho"
              label="Xưng hô"
              min-width="100"
            ></el-table-column>
            <el-table-column
              prop="ho_ten"
              label="Họ tên"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="dien_thoai"
              label="Điện thoại"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="email"
              label="Email"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              prop="thoi_diem_tao"
              label="Thời điểm đăng ký"
              align="center"
              width="160"
              :sortable="mData.tableRules.allowSorting"
            >
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import DataForm from "../../../dataForm/dataFormDangKyDongHo";
import mushroom from "viettoc-api";
export default {
  props: {
    phone: String,
    thoiDiemTao: String,
    trangThaiDuyet: String,
    liDo: String,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      numberTuChoi: 0,
      activeNames: this.$router.currentRoute.name === 'ChiTietDangKyDongHo' ? ["1"] : ["2"],
      url: "",

      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
    };
  },
  methods: {
    async fn_initTable() {
      let dataFilter = {
        filters: ["dien_thoai=" + this.phone],
        fields:
          "id,ten_dong_ho,quoc_gia_id,tinh_id,huyen_id,xa_id,dia_chi,khoang_dinh,xung_ho,ho_ten,dien_thoai,email,trang_thai,li_do_tu_choi,thoi_diem_tao,thoi_diem_cap_nhat,dong_ho_id,thoi_diem_duyet",
        sort: "-thoi_diem_tao",
        limit: 1000,
      };
      try {
        const response = await mushroom.dang_ky.listAsync(dataFilter);
        if (response.result) {
          let res = response.result.filter(
            (item) => item.thoi_diem_tao !== this.thoiDiemTao
          );

          res.forEach((item) => {
            item.url = "";
            if (
              item.trang_thai == "dang_cho" ||
              item.trang_thai == "dang_xu_ly"
            ) {
              this.activeNames = ["1"];
            } else this.choPhepShowBang = ["2"];
          });
          this.mData.tableRules.data = await this.fn_changeData(res);
          this.numberTuChoi = res.length;
        }
      } catch (e) {
        console.log(e.result);
        if (e.code === 4) {
          this.spin = false;
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          this.spin = false;
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        }
      }
    },

    fn_changeData(data) {
      data.forEach((element) => {
        element.thoi_diem_tao = MethodService.formatDate(
          element.thoi_diem_tao,
          "datetime"
        );
        element.dien_thoai = MethodService.formatPhone(element.dien_thoai);
        console.log("location.pathname", location.pathname);
        element.url =
          location.origin +
          location.pathname.replace(location.pathname.slice(71), element.id);
        if (element.xung_ho == "ong") {
          element.xung_ho = "Ông";
        }
        if (element.xung_ho == "ba") {
          element.xung_ho = "Bà";
        }
        if (element.xung_ho == "anh") {
          element.xung_ho = "Anh";
        }
        if (element.xung_ho == "chi") {
          element.xung_ho = "Chị";
        }
        if (element.xung_ho == "co") {
          element.xung_ho = "Cô";
        }
        if (element.xung_ho == "chu") {
          element.xung_ho = "Chú";
        }
      });
      //
      return data;
    },

    fn_showHistory() {
      if (this.choPhepShowBang) {
        this.showTable = !this.showTable;
      }
    },
  },
  async created() {
    await this.fn_initTable();
  },
  watch: {
    phone(oldValue, newValue) {
      this.fn_initTable();
    },
    thoiDiemTao(oldValue, newValue) {
      this.fn_initTable();
    },
    trangThaiDuyet(oldValue, newValue) {
      this.fn_initTable();
    },
    liDo(oldValue, newValue) {
      this.fn_initTable();
    },
  },
};
</script>
<style  scoped>
.history-register {
  color: #fff;
  border: none;
  background-color: #2e8ebd;
  width: fit-content;
  padding: 5px 10px;
  border-radius: 16px;
  cursor: pointer;
  position: relative;
  min-width: 157px;
  margin-right: 10px;
}

.history-register span {
  position: absolute;
  right: 5px;
  top: 3px;
  width: 25px;
  height: 25px;
  font-size: 12px;
  overflow: hidden;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  color: #f56c6c;
  font-weight: bold;
  z-index: 2;
  line-height: 21px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.noti,
.tu-choi-group {
  display: flex;
  align-items: center;
}
.trang-thai {
  height: 40px;
  line-height: 40px;
}
.tu-choi-group {
  margin-top: 10px;
}
.tu-choi-content {
  white-space: nowrap;
  /* max-width: 390px;  */
  overflow: hidden;
  text-overflow: ellipsis;
}
.tu-choi-btn {
  background-color: #409eff;
  padding: 5px 10px;
  color: #fff;
  border-radius: 5px;
  margin-right: 10px;
  width: 71px;
}

.value-list {
  background: rgb(102, 177, 255);
  margin-left: 5px;
  height: 20px;
  line-height: 22px;
  border-radius: 10px;
  color: #fff;
  text-indent: initial;
  padding: 0 10px;
}
</style>
